import type { AdvisorRecRow } from '../../unifiedcommerce/framework';

type Props = { recommendations?: AdvisorRecRow[] };

export function AIMarketplaceAdvisorPanel({ recommendations = [] }: Props) {
  return (
    <div className="space-y-2">
      {recommendations.map((r) => (
        <div key={r.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium text-brand-600">{r.capability}</p>
              <p className="mt-0.5 text-sm font-medium">{r.title}</p>
              <p className="mt-1 text-xs text-slate-600 dark:text-slate-400">{r.detail}</p>
            </div>
            <p className="shrink-0 text-lg font-semibold text-success-600">{r.roi}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
